module.exports = __webpack_public_path__ + "static/img/bot2.22effb29.png";